export const PAGE_KEY = 'payroll-admin-payroll-type-package';
